import {
  MockMap,
} from '@ama-sdk/core';
import {
  Email,
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  ContextualSeatmapDataRepository,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';

const email1: Email = {
  address: 'first.traveler@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const email2: Email = {
  address: 'second.traveler@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.INF, JourneyTravelerRepository.WOMAN, JourneyTravelerRepository.CHD], {}).items,
  contacts: [email1, email2]
};

const journeys = combineJourneys([journeyTemplate]).items;

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
/**
 * OW 1 Journey
 * Check-in 2ADT, 1INF + check-in 1CHD
 * No baggage
 */
const missingBp = combineBoardingPassResults([{
  boardingPassData: {
    traveler: journeys[0].travelers[3]
  },
  documentType: 'confirmation'
}, {
  boardingPassData: {
    traveler: journeys[0].travelers[1]
  },
  documentType: 'confirmation'
}], {
  journeyElementIds
}).items;

export const ow1Journey2Adt1Chd1InfMultiPaxsMissingBpRetrieve: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(missingBp, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    ], 201)
  ],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)],
  removeTravelersFromJourney: [createMockData({})]
};
